export const CLASS_ID_PATTERN = /OB_CL\d{1,}/;
export const COMPETITION_ID_PATTERN = /OB_TY\d{1,}/;

export const COMPETITION_MATCHES = 'matches';
export const COMPETITION_OUTRIGHTS = 'outrights';

export const COMPETITION_MATCHES_TYPE = 'MTCH';

export const MAIN_MARKET_GROUP_ID = 'OB_MGMB';

export const COMPETITIONS = 'competitions';

export const SUBNAVIGATION_MATCHES = ['matches', 'partidos'];

export const DAILY_LIST = 'daily_list';

export const COUPONS = 'coupons';

export const MEETINGS = 'meetings';

export const BUILD_YOUR_ODDS = 'byo-hub';
